/**
 * User: herbert
 * Date: 20.02.16
 * Time: 21:44
 */

import Reflux from 'reflux';

import viewActions from '../actions/view-actions.js';
import stepActions from '../../slxstep/actions/step-actions.js';
import scopeActions from '../../stele/actions/scope-actions.js';

export default Reflux.createStore({
	init: function() {
		this.listenToMany(viewActions);
		this.listenToMany(scopeActions);
		this.listenToMany(stepActions);
		this.state = {viewBottom: false};
	},
	getInitialState: function() {
		// ? use stepStore to set global class or just keep it here and let stele.jsx decide how to switch beetween top and bottom
		return this.state;
	},
	viewHead: function() {
		if(this.state.viewBottom) {
			this.state.viewBottom = false;
			this.output();
		}
	},
	viewBottom: function() {
		if(!this.state.viewBottom) {
			this.state.viewBottom = true;
			this.output();
		}
	},
	// scopeActions.clear
	clear: function() {
		this.viewHead();
	},
	//// TODO stepActions: remove or reset to above
	//onNext: function() {
	//	this.viewHead();
	//},
	//onPrev: function() {
	//	this.viewHead();
	//},
	// output
	output: function() {
		this.trigger(this.getInitialState());
	}
});
